import React from 'react'
import { useDispatch } from 'react-redux'
import { IAxiosDefaultDataObject } from '../../config'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { updateSection } from './sectionsSlice'
import AdminDynamicCreateOrUpdatePage from '../admin/AdminDynamicCreateOrUpdatePage'
import { ISectionModel } from './SectionsApp'

export default function NewSectionPage() {

    const updateItem = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => dispatch(updateSection((item as ISectionModel)))

    return <AdminDynamicCreateOrUpdatePage updateItem={updateItem} />
}